import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, Clock } from "lucide-react";
import { useEffect, useState } from "react";
import { getSetting } from "../lib/api";
import { DEFAULT_CATEGORIES } from "../lib/constants";

export default function Footer() {
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);

  useEffect(() => {
    getSetting("home_categories").then((d) => {
      if (Array.isArray(d?.value) && d.value.length) setCategories(d.value);
    }).catch(() => {});
  }, []);

  const visibleCats = categories.filter((c) => c.visible !== false && c.value !== "All");

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#262626] py-14">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div
            className="font-serif-display"
            style={{ fontSize: 28, fontWeight: 600, color: "#F5D565", letterSpacing: "0.04em" }}
          >
            Her Box
          </div>
          <p className="font-body mt-4 max-w-sm" style={{ fontSize: 14, color: "rgba(255,255,255,0.65)", lineHeight: 1.6 }}>
            Statement jewelry. Made in small lots. Wrapped in our signature box.
          </p>
          <a
            href="https://www.instagram.com/her.box?igsh=czZ3NGVzNTQ5ZW8w&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 mt-5 transition-colors"
            style={{ color: "#F5D565", fontSize: 14, fontWeight: 500 }}
          >
            <Instagram size={18} strokeWidth={1.5} /> @her.box
          </a>
        </div>

        <div>
          <div className="font-ui mb-4" style={{ fontSize: 14, fontWeight: 600, color: "#F5D565", letterSpacing: "1px" }}>
            Shop
          </div>
          <ul className="space-y-3" data-testid="footer-shop-list">
            {visibleCats.map((c) => (
              <FooterLink key={c.value} to={`/shop?category=${encodeURIComponent(c.value)}`}>
                {c.label}
              </FooterLink>
            ))}
            <FooterLink to="/shop">The Edit</FooterLink>
          </ul>
        </div>

        <div>
          <div className="font-ui mb-4" style={{ fontSize: 14, fontWeight: 600, color: "#F5D565", letterSpacing: "1px" }}>
            Studio
          </div>
          <ul className="space-y-3">
            <FooterLink to="/jewelry-care">Care Guide</FooterLink>
            <FooterLink to="/shipping">Shipping</FooterLink>
            <FooterLink to="/returns">Returns</FooterLink>
            <FooterLink to="/privacy">Privacy</FooterLink>
            <FooterLink to="/terms">Terms</FooterLink>
            <FooterLink to="/admin">Admin</FooterLink>
          </ul>
        </div>

        <div>
          <div className="font-ui mb-4" style={{ fontSize: 14, fontWeight: 600, color: "#F5D565", letterSpacing: "1px" }}>
            Contact
          </div>
          <ul className="space-y-3 font-body" style={{ fontSize: 14 }}>
            <li className="flex items-start gap-2.5" style={{ color: "rgba(255,255,255,0.85)" }}>
              <Mail size={16} strokeWidth={1.5} style={{ color: "#F5D565", marginTop: 2 }} />
              <a href="mailto:herboxhelp@gmail.com" className="hover:text-[#F5D565]">herboxhelp@gmail.com</a>
            </li>
            <li className="flex items-start gap-2.5" style={{ color: "rgba(255,255,255,0.85)" }}>
              <Phone size={16} strokeWidth={1.5} style={{ color: "#F5D565", marginTop: 2 }} />
              <a href="tel:+919266359966" className="hover:text-[#F5D565]">+91 92663 59966</a>
            </li>
            <li className="flex items-start gap-2.5" style={{ color: "rgba(255,255,255,0.85)" }}>
              <Clock size={16} strokeWidth={1.5} style={{ color: "#F5D565", marginTop: 2 }} />
              <span>Mon–Sat · 11AM – 7PM IST</span>
            </li>
          </ul>
        </div>
      </div>
      <div
        className="mt-12 px-6 md:px-10 max-w-[1500px] mx-auto font-ui"
        style={{ fontSize: 12, letterSpacing: "0.18em", color: "rgba(255,255,255,0.45)", textTransform: "uppercase" }}
      >
        <span>© 2026 Her Box</span>
      </div>
    </footer>
  );
}

const FooterLink = ({ to, children }) => (
  <li>
    <Link
      to={to}
      className="font-body transition-colors hover:text-[#F5D565]"
      style={{ fontSize: 14, color: "rgba(255,255,255,0.85)", fontWeight: 500 }}
    >
      {children}
    </Link>
  </li>
);
